import * as React from "react";
import { IdPremiumType } from "../../constants/IdPremiumType";
import { IdStyles } from "../../less/IdStyles";
import { ImageBoxContainer } from "../generic/common/ImageBoxContainer";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { Icon } from "../generic/icon/Icon";
import { TextLoca } from "../generic/text/TextLoca";
export var ProductInformation = function (_a) {
    var item = _a.item, children = _a.children;
    var locaKey = item.locaKey, premiumType = item.premiumType;
    var resourceIcon = getResourceIcon(item);
    var imageBoxContainerClass = IdStyles.ImageBoxContainerSmall;
    if (premiumType) {
        if (premiumType === IdPremiumType.Blue) {
            imageBoxContainerClass = IdStyles.ImageBoxContainerPremiumSmall;
        }
        else if (premiumType === IdPremiumType.Purple) {
            imageBoxContainerClass = IdStyles.ImageBoxContainerPremiumSpecialSmall;
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: IdStyles.TextButtonHeading + " " + IdStyles.TextAlignCenter },
            React.createElement(TextLoca, { id: locaKey })),
        React.createElement("div", { className: "farm-management-detail__information" },
            React.createElement("div", { className: "farm-management-detail__information-image" },
                React.createElement(ImageBoxContainer, { className: imageBoxContainerClass },
                    React.createElement("div", { className: "farm-management-master__item" },
                        React.createElement(Icon, { icon: resourceIcon, styleId: IdStyles.IconExtraLarge })))),
            children)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/farm-management/ProductInformation.tsx
// module id = 2646
// module chunks = 3